module.exports = __webpack_public_path__ + "static/media/summary_1_for_me.43f167ed.png";